import { deleteCookie, getCookieValue } from '@do/seashell';
import { useEffect, useState } from 'react';

// Used for checking for one-time read (flash) cookies
// Checks for the cookie and value and if present returns
// that the cookie was found and deletes it
export default function useOneTimeCookie(cookieName: string, cookieValue: string): boolean {
  const [isCookiePresent, setCookieIsPresent] = useState<boolean>(false);
  const cookie = getCookieValue(cookieName);

  useEffect(() => {
    if (cookie === cookieValue) {
      setCookieIsPresent(true);
      deleteCookie(cookieName);
    }
  }, [cookie, cookieName, cookieValue]);

  return isCookiePresent;
}
